"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectResultsEventCountersFetchItems = exports.selectResultCountersListV3 = exports.selectResultCountersSportIds = exports.selectResultCountersListV2 = exports.selectEventResultCountersByFilterKey = exports.selectSportsCountersListV2 = exports.selectTournamentCountByKeyAndId = exports.selectEventSportCountersByFilterKey = exports.selectSportsCountersTotalCount = exports.selectSportsCountersList = exports.selectSportCountersByTab = exports.selectSportCountersProvider = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const selectors_1 = require("../CommonDataProvider/selectors");
const selectors_2 = require("../ResultsProvider/selectors");
const api_1 = require("../../utils/api");
const slice_1 = require("./slice");
const selectSportCountersProvider = (state) => state.sportCountersProvider || slice_1.initialState;
exports.selectSportCountersProvider = selectSportCountersProvider;
const EMPTY_COUNTERS = {};
const selectSportCountersByTab = (state, currentMenuTab) => state.sportCountersProvider[currentMenuTab].entries || EMPTY_COUNTERS;
exports.selectSportCountersByTab = selectSportCountersByTab;
exports.selectSportsCountersList = (0, toolkit_1.createSelector)([selectors_1.selectSportsList, exports.selectSportCountersByTab], (sportsList, sportCountersByTab) => sportsList
    .filter((sport) => !!sport)
    .map((sport) => {
    var _a;
    return ({
        ...sport,
        count: (_a = sportCountersByTab[sport.id]) === null || _a === void 0 ? void 0 : _a.count,
    });
})
    // TODO remove filter after backend supports filtering
    .filter(({ count }) => count));
exports.selectSportsCountersTotalCount = (0, toolkit_1.createSelector)([selectors_1.selectSportsList, exports.selectSportCountersByTab], (sportsList, sportCountersByTab) => sportsList
    .filter((sport) => !!sport)
    .map((sport) => {
    var _a;
    return ({
        ...sport,
        count: (_a = sportCountersByTab[sport.id]) === null || _a === void 0 ? void 0 : _a.count,
    });
})
    // TODO remove filter after backend supports filtering
    .filter(({ count }) => count)
    .map(({ count }) => count)
    .reduce((acc, cur) => acc + cur, 0));
const selectEventSportCountersByFilterKey = (state, key) => {
    const eventSportCounter = state.sportCountersProvider.eventSportCounters[key];
    return eventSportCounter ? eventSportCounter.data : null;
};
exports.selectEventSportCountersByFilterKey = selectEventSportCountersByFilterKey;
exports.selectTournamentCountByKeyAndId = (0, toolkit_1.createSelector)([
    exports.selectEventSportCountersByFilterKey,
    (_, key) => key,
    (_, __, tournamentId) => tournamentId,
], (eventSportCounters, _, tournamentId) => {
    var _a, _b;
    const tournament = (_b = (_a = eventSportCounters === null || eventSportCounters === void 0 ? void 0 : eventSportCounters.byTournament) === null || _a === void 0 ? void 0 : _a.entries) === null || _b === void 0 ? void 0 : _b[tournamentId];
    return tournament ? tournament.count : null;
});
exports.selectSportsCountersListV2 = (0, toolkit_1.createSelector)([
    selectors_1.selectSportsList,
    (_, key) => key,
    exports.selectEventSportCountersByFilterKey,
], (sportsList, key, eventSportCounters) => {
    var _a;
    const counters = ((_a = eventSportCounters === null || eventSportCounters === void 0 ? void 0 : eventSportCounters.bySport) === null || _a === void 0 ? void 0 : _a.entries) || {};
    return sportsList.reduce((acc, sport) => {
        var _a;
        if (!sport)
            return acc;
        const count = ((_a = counters[sport.id]) === null || _a === void 0 ? void 0 : _a.count) || 0;
        if (count > 0) {
            acc.push({
                ...sport,
                count,
            });
        }
        return acc;
    }, []);
});
const selectEventResultCountersByFilterKey = (state, key) => {
    const eventResultCounters = state.sportCountersProvider.eventResultCounters[key];
    return eventResultCounters ? eventResultCounters.data : null;
};
exports.selectEventResultCountersByFilterKey = selectEventResultCountersByFilterKey;
const RESULT_COUNTERS_V2_EMPTY_ARRAY = [];
exports.selectResultCountersListV2 = (0, toolkit_1.createSelector)([
    selectors_1.selectSports,
    (state, key) => (0, exports.selectEventResultCountersByFilterKey)(state, key),
    selectors_2.selectResultsFilterSportId,
], (sports, resultCounters, currentSportId) => {
    var _a;
    const resultCountersEntries = ((_a = resultCounters === null || resultCounters === void 0 ? void 0 : resultCounters.bySport) === null || _a === void 0 ? void 0 : _a.entries) || {};
    return Object.values(resultCountersEntries).flatMap((counter) => {
        const sport = sports[counter.id];
        if (!counter.count || !sport)
            return RESULT_COUNTERS_V2_EMPTY_ARRAY;
        return {
            ...sport,
            ...counter,
            isActive: counter.id === currentSportId,
        };
    });
});
const selectResultCountersSportIds = (state, key) => {
    var _a, _b, _c;
    const eventCountersBySport = (_c = (_b = (_a = (0, exports.selectEventResultCountersByFilterKey)(state, key)) === null || _a === void 0 ? void 0 : _a.bySport) === null || _b === void 0 ? void 0 : _b.entries) !== null && _c !== void 0 ? _c : {};
    return Object.keys(eventCountersBySport).map(Number);
};
exports.selectResultCountersSportIds = selectResultCountersSportIds;
const RESULT_COUNTERS_V3_EMPTY_ARRAY = [];
exports.selectResultCountersListV3 = (0, toolkit_1.createSelector)([
    selectors_1.selectSports,
    (state, key) => {
        return (0, exports.selectEventResultCountersByFilterKey)(state, key);
    },
], (sports, resultCounters) => {
    var _a;
    const eventCountersBySport = ((_a = resultCounters === null || resultCounters === void 0 ? void 0 : resultCounters.bySport) === null || _a === void 0 ? void 0 : _a.entries) || {};
    if (Object.keys(eventCountersBySport).length === 0) {
        return RESULT_COUNTERS_V3_EMPTY_ARRAY;
    }
    const sportWithCounters = [];
    for (const eventCounter of Object.values(eventCountersBySport)) {
        const sport = sports[eventCounter.id];
        if (!eventCounter.count || !sport) {
            continue;
        }
        sportWithCounters.push({
            ...sport,
            count: eventCounter.count,
        });
    }
    return sportWithCounters;
});
const selectResultsEventCountersFetchItems = (state, key) => {
    var _a;
    return (((_a = (0, exports.selectSportCountersProvider)(state).eventResultCounters[key]) === null || _a === void 0 ? void 0 : _a.fetchItems) ||
        api_1.requestInitialState);
};
exports.selectResultsEventCountersFetchItems = selectResultsEventCountersFetchItems;
//# sourceMappingURL=selectors.js.map